import { makeAutoObservable, toJS } from "mobx";
class stateRegion {
  constructor() {
    makeAutoObservable(this);
  }

  collectionRegion = [];
  visibleRegion = ["RU", "BY"];
  region = "RU";

  filterRegion = (region) => {
    const regionID = this.visibleRegion.find((r) => r === region);
    if (regionID) {
      this.visibleRegion = [...this.visibleRegion.filter((r) => r !== region)];
    } else {
      this.visibleRegion = [...this.visibleRegion, region];
    }
    localStorage.setItem("company_region", JSON.stringify(this.visibleRegion));
  };

  setParameters = (parametr, value) => {
    this[`${parametr}`] = value;
  };
}
export default new stateRegion();
